import { useEffect, useState } from 'react';
import LeaderboardService, { LeaderboardScopesResponse } from '../../application/services/LeaderboardService';

interface LeaderboardScopesState {
  isLoading: boolean;
  error: string | null;
  scopes: LeaderboardScopesResponse | null;
}

/** Countries/cities that currently have at least one leaderboard entry — backs the country/city
 * selectors on all three board pages and the countryCode/citySlug -> id resolution they each need. */
export function useLeaderboardScopes(): LeaderboardScopesState {
  const [state, setState] = useState<LeaderboardScopesState>({ isLoading: true, error: null, scopes: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const scopes = await LeaderboardService.getScopes();
        if (!cancelled) {
          setState({ isLoading: false, error: null, scopes });
        }
      } catch (err) {
        if (!cancelled) {
          setState({ isLoading: false, error: err instanceof Error ? err.message : 'Failed to load regions', scopes: null });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
